export default __webpack_public_path__ + "static/media/3.63fa9e5b.jpg";